export default __webpack_public_path__ + "f0887731d5b04e6a6ddbe22b2490ef7c.png";